module.exports = __webpack_public_path__ + "static/media/au-aid-logo-white.94a0529b.svg";